import React, { useMemo } from 'react';

import { Button } from 'devextreme-react/button';
import { Tooltip } from 'devextreme-react/tooltip';
import Box, { Item as BoxItem } from 'devextreme-react/box';
import AntLocalization from '../utils/AntLocalization';

export default function (props) {
    const errorText = useMemo(() => AntLocalization.translateText(props.text), [props.text]);

    const errorDetails = useMemo(() => {
        if (!Array.isArray(props.errors)) return [];
        return props.errors.map(e => AntLocalization.translateText(e)).join('\n').split('\n');
    }, [props.errors]);

    const hasDetails = errorDetails.length > 0;
    const errorId = props.id;

    if (!errorText) return null;

    return (
        <div className={props.hasBackground ? 'ant-error-pannel' : 'ant-error-text'}>
            <Box direction="row" height="100%" width="100%">
                <BoxItem baseSize={40}>
                    <Button
                        className="ant-grid-icon ant-icon-error"
                        id={errorId}
                        type="normal"
                        stylingMode="text"
                        focusStateEnabled={false}
                        hoverStateEnabled={false}
                        activeStateEnabled={false}
                    >
                        <i className="dx-icon dx-icon-info" />
                    </Button>
                </BoxItem>

                <BoxItem ratio={1}>
                    <span className="ant-error-text">{errorText}</span>
                </BoxItem>
            </Box>

            {hasDetails && (
                <Tooltip
                    target={`#${errorId}`}
                    className="ant-tooltip"
                    hideEvent="mouseleave"
                    showEvent={{
                        name: 'mouseenter dxclick keyup'
                    }}
                    hideOnOutsideClick={true}
                >
                    {errorDetails.map((item, key) => (
                        <React.Fragment key={key}>
                            <label>{item}</label>
                            {key < errorDetails.length - 1 && <br />}
                        </React.Fragment>
                    ))}
                </Tooltip>
            )}
        </div>
    );
}
